/**
 * Caller ID — mobil (Capacitor) uygulamada gelen aramayı dinler, sunucuya gönderir, otomatik destek kaydı oluşur.
 * Rehberde kayıtlı ise arayan adı da gönderilir.
 */

import { registerPlugin } from "@capacitor/core";

const STORAGE_KEY_CONFIG = "caller_id_background_config";

const IncomingCall = registerPlugin("IncomingCall");

export function isNativePlatform() {
  try {
    return typeof window !== "undefined" && window.Capacitor?.isNativePlatform?.();
  } catch {
    return false;
  }
}

/**
 * Caller ID dinleyiciyi başlatır (sadece native'de; giriş yapınca AuthContext çağırır).
 * @param {Object} opts
 * @param {string} opts.baseUrl - API base (örn. .../api/caller-id)
 * @param {string} [opts.apiKey] - x-caller-id-api-key
 * @param {string} [opts.devicePhone] - Cihaz numarası (Kullanici.Tel)
 */
export function startCallerIdBackground(opts) {
  if (!opts || !opts.baseUrl) return;
  const baseUrl = opts.baseUrl.replace(/\/+$/, "");
  const apiKey = opts.apiKey || "";
  const devicePhone = opts.devicePhone || "";

  try {
    const config = { baseUrl, apiKey, devicePhone, startedAt: new Date().toISOString() };
    if (typeof localStorage !== "undefined") {
      localStorage.setItem(STORAGE_KEY_CONFIG, JSON.stringify(config));
    }

    if (!isNativePlatform()) return;

    IncomingCall.start({ apiUrl: baseUrl, apiKey, devicePhone }).catch((e) => {
      console.warn("[CallerId] start:", e?.message);
    });
  } catch (e) {
    console.warn("[CallerId] startCallerIdBackground:", e?.message);
  }
}

/**
 * Caller ID dinleyiciyi durdurur (çıkış yapınca).
 */
export function stopCallerIdBackground() {
  try {
    if (typeof localStorage !== "undefined") {
      localStorage.removeItem(STORAGE_KEY_CONFIG);
    }
    if (!isNativePlatform()) return;
    IncomingCall.stop().catch((e) => console.warn("[CallerId] stop:", e?.message));
  } catch (e) {
    console.warn("[CallerId] stopCallerIdBackground:", e?.message);
  }
}

/**
 * Kayıtlı config varsa döndürür (debug veya UI göstergesi için).
 */
export function getCallerIdConfig() {
  try {
    const raw = typeof localStorage !== "undefined" ? localStorage.getItem(STORAGE_KEY_CONFIG) : null;
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}
